import React from "react";
import { Page } from "../../components/page/page";
import styles from "./intuition.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIntuition } from "../../store/stateSlice";

const options = [
  {
    value: "I follow my intuition in every decision",
    icon: "🌀",
  },
  {
    value: "I trust it when it feels right",
    icon: "🎯",
  },
  {
    value: "I prefer to rely on logic and facts",
    icon: "📊",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const IntuitionPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="How often do you trust your intuition?"
      hideContinueButton={true}
      currentStep={2}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../energy"
              onClick={() => dispatch(setIntuition(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { IntuitionPage };
